<template>
    <el-container class="main-container">
        <el-header class="service-header">
            <img class="auth-logo" src="/images/logo.webp" alt="PickTrip" style="height: 42px; width: auto; max-width: 160px; object-fit: contain;">
        </el-header>
        <el-main class="el-mainn">
            <div class="custom-container text-center">
                <h2>Welcome to BON TRAVEL CRM!</h2>
                <p>Please Login using your Email/Mobile to continue</p>
                <el-card class="box-card" width="500">

                    <div v-if="otpsent">
                        <el-image style="height: 100px" src="/images/otpa.png" shape="square"/>
                        <p>An OTP (valid for next 15 mins.) has been sent to you on</p>
                        <el-text class="text" tag="p">{{ user.phone }} / {{ user.email }}</el-text>
                        <div style="display: flex; flex-direction: row">
                            <v-otp-input
                                ref="otpInput"
                                v-model:value="user.otp"
                                input-classes="otp-input"
                                separator="-"
                                :num-inputs="6"
                                :should-auto-focus="true"
                                input-type="letter-numeric"
                                :conditionalClass="['one', 'two', 'three', 'four', 'five', 'six']"
                                :placeholder="['*', '*', '*', '*','*','*']"
                                @on-complete="verifyotp"
                                :is-disabled="loading2"
                            />
                        </div>

                        <el-text v-if="result2 && result2.success == false" class="mx-6" type="danger">
                            {{ result2.message }}
                        </el-text>

                        <el-row>
                            <el-col>
                                <el-button
                                    v-if="!otpblocked"
                                    @click="verifyotp"
                                    class="cbtn"
                                    type="primary"
                                    :disabled="loading2 || loading || user.otp.length !== 6"
                                    :loading="loading2"
                                    size="large"
                                >Continue</el-button>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col>
                                <el-button
                                    @click="sendotp"
                                    class="cbtn"
                                    type="warning"
                                    :disabled="loading"
                                    :loading="loading"
                                    size="large"
                                    plain
                                >Resend OTP</el-button>
                            </el-col>
                        </el-row>
                    </div>

                    <div v-else>
                        <div v-if="userslist.length > 0">
                            <el-card class="user-card" v-for="(user, key) in userslist" :key="user.id">
                                <el-avatar
                                    :src="user.image"
                                    @click="loginuser(user)"
                                />
                                <div class="details" @click="loginuser(user)">
                                    <el-text tag="b">{{ user.name }}</el-text>
                                    <el-text>{{ user.email }}</el-text>
                                </div>
                                <el-icon @click="deleteuser(user.id)"><Close /></el-icon>
                            </el-card>
                        </div>
                        <el-avatar v-else :size="100" src="/images/user.png" />

                        <el-form
                            ref="ruleFormRef"
                            :model="form"
                            status-icon
                            :rules="rules"
                            label-width="120px"
                            class="demo-ruleForm"
                            label-position="top"
                        >
                            <el-form-item label="EMAIL ID / MOBILE NUMBER" prop="phoneemail">
                                <el-input size="large" v-model="form.phoneemail" placeholder="EMAIL ID / MOBILE NUMBER" />
                            </el-form-item>

                            <el-text v-if="result && result.success == false" class="mx-6" type="danger">
                                {{ result.message }}
                            </el-text>

                            <el-button
                                class="cbtn"
                                @click="submitForm"
                                type="primary"
                                :disabled="loading"
                                :loading="loading"
                                size="large"
                            >Continue</el-button>
                        </el-form>
                    </div>

                </el-card>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import VOtpInput from "vue3-otp-input";
import {
    ElIcon, ElRow, ElCol, ElImage, ElContainer, ElHeader, ElMain, ElAside,
    ElCard, ElButton, ElText, ElSpace, ElAvatar, ElInput, ElForm, ElFormItem
} from 'element-plus';
import 'element-plus/dist/index.css';
import { Close } from '@element-plus/icons-vue';

const checkInput = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('Please enter your Email Id/Mobile Number'));
    }
    if (isNaN(value)) {
        const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (regex.test(value)) {
            callback();
        } else {
            callback(new Error('You have entered an invalid Email Id.'));
        }
    } else {
        if (value.length !== 10) {
            callback(new Error('Please enter a valid mobile number to proceed'));
        } else {
            callback();
        }
    }
};

export default {
    name: "OtpVerify",
    components: {
        Close, ElIcon, ElRow, ElCol, ElImage, ElContainer, ElHeader, ElMain, ElAside,
        ElCard, ElButton, VOtpInput, ElText, ElSpace, ElAvatar, ElInput, ElForm, ElFormItem
    },
    data() {
        return {
            userslist: [],
            otp: '',
            loading: false,
            loading2: false,
            result: null,
            result2: null,
            otpsent: false,
            otpblocked: false,
            user: {
                phone: '**********',
                email: '****@bontravelindia.com',
                otp: ''
            },
            form: {
                phoneemail: ''
            },
            rules: {
                phoneemail: [
                    {
                        validator: checkInput,
                        trigger: ['blur', 'change'],
                    }
                ]
            }
        };
    },
    mounted() {
        let userslist = JSON.parse(localStorage.getItem("userslist"));
        if (userslist == null) {
            userslist = [];
        }
        this.userslist = userslist;
    },
    methods: {
        submitForm() {
            const formEl = this.$refs.ruleFormRef;
            if (!formEl) return;
            formEl.validate((valid) => {
                if (valid) {
                    this.sendotp();
                } else {
                    return false;
                }
            });
        },
        sendotp() {
            this.loading = true;
            let currentObj = this;
            axios.post('/sendotp', this.form).then(function (response) {
                currentObj.result = response.data;
                currentObj.loading = false;
                if (currentObj.result.success) {
                    currentObj.otpsent = true;
                    currentObj.user.phone = currentObj.result.user.mobile;
                    currentObj.user.email = currentObj.result.user.email;
                }
            }).catch(function (error) {
                currentObj.loading = false;
            });
        },
        verifyotp() {
            this.loading2 = true;
            let currentObj = this;
            axios.post('/verifyuotp', this.user).then(function (response) {
                currentObj.result2 = response.data;
                currentObj.loading2 = false;
                currentObj.user.otp = "";
                currentObj.otpblocked = currentObj.result2.blocked;
                if (currentObj.result2.success) {
                    currentObj.deleteuser(currentObj.result.user.id);
                    currentObj.userslist.push(currentObj.result.user);
                    localStorage.setItem("userslist", JSON.stringify(currentObj.userslist));
                    window.location.href = "/dashboard";
                }
            }).catch(function (error) {
                currentObj.loading2 = false;
                currentObj.user.otp = "";
            });
        },
        loginuser(user) {
            this.form.phoneemail = user.email;
            this.sendotp();
        },
        deleteuser(id) {
            this.userslist = this.userslist.filter((e) => e.id !== id);
            localStorage.setItem("userslist", JSON.stringify(this.userslist));
        }
    }
};
</script>

<style scoped>
.custom-container {
}

.main-container {
    height: 100vh;
}

.service-header {
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0 20px;
    background: #fff;
}

.auth-logo {
    height: 42px;
    width: auto;
    max-width: 160px;
    object-fit: contain;
}

.el-mainn {
    background-color: #b9b9b93b;
}

.box-card {
    margin: 50px auto;
    width: fit-content;
    min-width: 500px;
}

.side {
    --el-aside-width: 400px;
    align-items: center;
    display: flex;
}

.card-header {
    text-align: center;
}

.text {
    text-align: center;
    font-weight: 700;
    margin: 15px;
    font-size: 15px;
}

.htext {
    text-align: center;
    font-weight: 700;
    font-size: 25px;
    color: white;
}

::placeholder {
    color: red;
    opacity: 1; /* Firefox */
}

.el-card__header_1 {
    background-color: #e6e6e6;
}

.cbtn {
    margin-top: 20px;
    width: 100%;
}
</style>